import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { Users } from 'my-lib-sanfelici/my-lib-sanfelici';
import { UsersService } from 'my-lib-sanfelici';
import { ContattiService } from 'my-lib-sanfelici';
import { NewMapsDialogViewComponent } from '../../new-maps/new-maps-dialog-view/new-maps-dialog-view.component';

@Component({
  selector: 'app-contatti-form',
  templateUrl: './contatti-form.component.html',
  styleUrls: ['./contatti-form.component.scss']
})
export class ContattiFormComponent implements OnInit {
@Input() user: Users;

  constructor(
    private conttattiservice: ContattiService,
    public dialog: MatDialog,
    private usersservice: UsersService) { }
    delete() {
this.conttattiservice.delete(this.user.id).then(()=>{
  if (this.user.contatto) {

  } else {
    this.user.contatto = {nome: null, cognome: null, fiscalcode: null, phone: null};

  }
});

    }
  onchange($event) {

    this.usersservice.update(this.user);


  }
  openDialog(): void {
    const dialogRef = this.dialog.open(NewMapsDialogViewComponent, {

    });
    dialogRef.afterClosed().subscribe(result => {
      if(result){
      this.user.contatto.address = result;
      this.usersservice.update(this.user);
      }
      console.log('The dialog was closed');

    });

  }
  ngOnInit() {
  }

}
